import styled from 'styled-components'
import { MapContext } from 'components/Mapbox/Mapbox'
import { useContext } from 'react'

export const Help = ({ visible }: { visible: boolean }) => {
  const context = useContext(MapContext)
  return (
    <HelpWrapper>
      <HelpRoot visible={visible}>
        <Title>Hilfe</Title>
        <h3>So bedienen Sie die interaktive Karte</h3>
        {!context.isMobile && (
          <Table>
            <tr>
              <td>Verschieben</td>
              <IconCell>
                <img
                  src={
                    require('./Icons/help_icons_mousebutton_move.svg').default
                  }
                />
              </IconCell>
              <IconCell>oder</IconCell>
              <IconCell>
                <img
                  src={require('./Icons/help_icons_touchpad_move.svg').default}
                />
              </IconCell>
            </tr>
            <tr>
              <td>Zoomen</td>
              <IconCell>
                <img
                  src={
                    require('./Icons/help_icons_mousewheel_up_down.svg').default
                  }
                />
              </IconCell>
              <IconCell>oder</IconCell>
              <IconCell>
                <img
                  src={
                    require('./Icons/help_icons_touchpad_up_down.svg').default
                  }
                />
              </IconCell>
            </tr>
            <tr>
              <td>Perspektive drehen</td>
              <IconCell>
                <img src={require('./Icons/help_icons_ctrl_key.svg').default} />
              </IconCell>
              <IconCell>+</IconCell>
              <IconCell>
                {' '}
                <img
                  src={
                    require('./Icons/help_icons_mousebutton_move.svg').default
                  }
                />
              </IconCell>
            </tr>
            <tr className='noBorder'>
              <td></td>
              <IconCell>
                <img src={require('./Icons/help_icons_ctrl_key.svg').default} />
              </IconCell>
              <IconCell>+</IconCell>
              <IconCell>
                <img
                  src={require('./Icons/help_icons_touchpad_move.svg').default}
                />
              </IconCell>
            </tr>
            <tr className='noBorder'>
              <td colSpan={4} className='close'>
                <button
                  onClick={() => {
                    context.setShowHelp && context.setShowHelp(false)
                  }}
                >
                  Schliessen
                </button>
              </td>
            </tr>
          </Table>
        )}
        {/* 
        
        
        
        
        */}
        {context.isMobile && (
          <Table>
            <tr>
              <td>Verschieben</td>
              <IconCell>
                <img
                  src={require('./Icons/help_icons_mobile_move.svg').default}
                />
              </IconCell>
            </tr>
            <tr>
              <td>Zoomen</td>
              <IconCell>
                <img
                  src={require('./Icons/help_icons_mobile_pinch.svg').default}
                />
              </IconCell>
            </tr>
            <tr>
              <td>Perspektive drehen</td>
              <IconCell>
                <img
                  src={require('./Icons/help_icons_mobile_up_down.svg').default}
                />{' '}
              </IconCell>
            </tr>

            <tr className='noBorder'>
              <td colSpan={2} className='close'>
                <button
                  onClick={() => {
                    context.setShowHelp && context.setShowHelp(false)
                  }}
                >
                  Schliessen
                </button>
              </td>
            </tr>
          </Table>
        )}
      </HelpRoot>
    </HelpWrapper>
  )
}

const Table = styled.table`
  table-layout: fixed;
  width: 100%;
  font-size: 15px;
  line-height: 1.1em;
  tr:not(.noBorder) {
    td {
      border-top: 1px solid var(--brandblue-bright-5);
      /* padding-top: 10px; */
      /* padding-bottom: 10px; */
      vertical-align: middle;
    }
  }
  td {
    padding: 0;
    &.close {
      text-align: center;
      padding-top: 15px;
      button {
        border: 0;
        background-color: var(--yellow-main);
        color: var(--brandblue-main);
        font-size: 18px;
        padding: 10px;
        &:hover {
          cursor: pointer;
          background-color: var(--brandblue-bright-3);
        }
      }
    }
  }
  img {
    width: 60px;
  }
`
const IconCell = styled.td`
  width: 60px;
  text-align: center;
  font-weight: 900;
  font-size: 15px;
  vertical-align: middle;
`
const IconCellLarge = styled(IconCell)`
  width: 180px;
  text-align: center;
`

const HelpWrapper = styled.div`
  position: absolute;
  z-index: 400;
  /* width: 100%; */
  bottom: 00px;
  left: 50%;
  transform: translate(-50%, 0);
`

const HelpRoot = styled.div<{ visible: boolean }>`
  position: absolute;
  bottom: ${(props) => (props.visible ? '10px' : '-700px')};
  left: 50%;
  transform: translate(-50%, 0);
  transition: bottom 0.3s ease-in-out;
  border-radius: 15px;
  border-top-right-radius: 15px;
  padding: 15px 30px;
  /* min-width: 50%; */
  width: 400px;
  background-color: var(--site-background);
  -webkit-box-shadow: 0px 10px 15px 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 10px 15px 5px rgba(0, 0, 0, 0.3);
  color: var(--text-color);
  @media screen and (max-width: 711px) {
    width: 280px;
  }
  span {
    font-weight: 300;
    font-size: 22px;
    margin-right: 10px;
    margin-left: 10px;
  }
  img {
    max-width: 60px;
  }
  h4 {
    /* flex:0 0 100%; */
    font-size: 15px;
    flex: 0 0 40%;
    /* text-align: center; */
    margin: 0;
    @media screen and (max-width: 711px) {
      font-size: 15px;
      max-width: 50%;
      line-height: 1.4em;
    }
  }

  h3 {
    margin-top: 0;
    width: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
  }
`

const Title = styled.div`
  line-height: 2em;
  font-size: 15px;
  width: 100%;
  text-align: center;
`
